// CSS
import './NavBarNew.css';
// React hooks
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// Skybase hooks
import { useAuth } from '../../context/AuthContext';
// External components/hooks
import { UserButton, Show } from '@clerk/react';                                            // user authe.
import { useMediaQuery } from "react-responsive";                                           // responsive CSS
// Media assets
import SkybaseLogoHorizontal from '../../assets/Logos/SkybaseLogoFullHorizontal.png';
import HamburgerMenuIcon from '../../assets/StandardIcons/hamburger-menu-icon.svg';
import CloseIcon from '../../assets/StandardIcons/close-icon-black.svg';



// =========
// NavBarNew – the Navigation Bar displayed on Landing Pages.
// =========
function NavBarNew() {

    // destructure global context
    const { activeUserJson } = useAuth();
    const location = useLocation();

    // init hooks
    const navigate = useNavigate('');

    // responsive CSS
    const isDesktop = useMediaQuery({ minWidth: 1025 });


    // ======================
    // handleHamToggleClick() – toggles open/close the Selection Menu
    // ======================
    const [isSelectionMenuOpen, setIsSelectionMenuOpen] = useState(false);
    const handleHamToggleClick = () => {
        
        // toggle state var
        setIsSelectionMenuOpen((prev) => !prev);
    }
    // onChange ('isDesktop') – immediately reset (close) selection menu if isDesktop
    useEffect(() => {
        if (isDesktop) {
            setIsSelectionMenuOpen(false);
        }
    }, [isDesktop]);


    // =====================
    // handlePageButtonClick(desiredPage: String) – redirects the User to the selected page (OR, just closes this modal if the User is already on their desired page)
    // =====================
    const handlePageButtonClick = (desiredPage) => {
        
        // compare exact strings (prevents the '/' page edge case err)
        if (location.pathname !== desiredPage) {
            
            // immediately redirect to the different page
            navigate(`../${desiredPage}`);
        } else {

            // or, just close the selection menu IFF already on desired page
            setIsSelectionMenuOpen(false);
        }
    }



    // JSX Component
    return(
        <>
            {/* === Normal === */}
            <div className='NavBarNew'>

                {/* Content region */}
                <div className='NavBarNew-content-area'>
                    
                    {/* Left content */}
                    <div className='NavBarNew-content-area-left'>
                        
                        {/* Skybase Logo (horizontal) */}
                        <img src={SkybaseLogoHorizontal} className='NavBarNew-skybase-logo' onClick={() => navigate('../')}/>
                        
                        {/* /library button */}
                        <div className='NavBarNew-button' onClick={() => navigate('../library')}>Databases</div>

                        {/* /pricing button */}
                        <div className='NavBarNew-button' onClick={() => navigate('../pricing')}>Pricing</div>
                        
                        {/* /contact button */}
                        <div className='NavBarNew-button' onClick={() => navigate('../contact')}>Contact</div>

                    </div>

                                
                    {/* Right content */}
                    <div className='NavBarNew-content-area-right'>
                        
                        {/* IFF Signed-OUT */}
                        <Show when="signed-out">
                            
                            {/* @clerk Sign-in Button */}
                            <button onClick={() => navigate('../login')} className='NavBarNew-login-button'>Sign in</button>

                            {/* @Clerk Sign-up Button */}
                            <button onClick={() => navigate('../create-account')} className='NavBarNew-sign-up-button'>Create New Account</button>

                        </Show>

                        {/* IFF Signed-IN */}
                        <Show when="signed-in">
                            
                            {/* Postgres CurrentUser name */}
                            <span className='NavBarNew-profile-text--identity'>{activeUserJson?.first_name} {activeUserJson?.last_name} {!activeUserJson && <span className='faded-text'>Server connection failed.</span>}</span>
                            
                            {/* @Clerk User Button */}
                            <div className='NavBarNew-profile-image-box'><UserButton/></div>
                        
                        </Show>
                    </div>
                </div>
            </div>

            {/* === Hamburger === */}
            <div className='NavBarNewHamburger'>

                {/* Ham toggle */}
                { !isSelectionMenuOpen && <div className='NavBarNewHamburger-ham-toggle' onClick={() => handleHamToggleClick()}>
                        
                        {/* ham toggle icon */}
                        <img src={HamburgerMenuIcon} className='NavBarNewHamburger-ham-toggle-img'/>

                </div>}
                
            </div>

            {/* Ham selection menu */}
            <div className={`NavBarNewHamburger-selection-menu ${isSelectionMenuOpen ? 'is-open' : ''}`}>
                
                {/* header */}
                <div className='NavBarNewHamburger-selection-menu-header'>

                    {/* close button */}
                    <div onClick={() => handleHamToggleClick()} className='NavBarNewHamburger-selection-menu-header-close-button'>
                        
                        {/* close button icon */}
                        <img src={CloseIcon} className='NavBarNewHamburger-selection-menu-header-close-button-icon'/>

                    </div>


                    {/* profile content */}
                    <div className='NavBarNewHamburger-selection-menu-header-profile-content'>

                        {/* @clerk !isSignedIn */}
                        <Show when='signed-out'>
                            
                            {/* sign-in button */}
                            <button onClick={() => navigate('/login', {state: { from: location.pathname }}) } className='NavBarNewHamburger-selection-menu-header-profile-content-login-button'>Sign in</button>

                            {/* create account button */}
                            <button onClick={() => navigate('/create-account', {state: { from: location.pathname }}) } className='NavBarNewHamburger-selection-menu-header-profile-content-create-account-button'>Create account</button>
                        
                        </Show>

                        {/* @clerk isSignedIn */}
                        <Show when='signed-in'>

                            {/* @clerk user button */}
                            <div className='NavBarNewHamburger-selection-menu-header-profile-content-user-button'><UserButton/></div>

                        </Show>

                    </div>

                </div>
                

                {/* item repeater */}
                <div className='NavBarNewHamburger-selection-menu-repeater'>

                    {/* / */}
                    <div onClick={() => handlePageButtonClick('/')} className='NavBarNewHamburger-selection-menu-repeater-item'>Home</div>

                    {/* /library */}
                    <div onClick={() => handlePageButtonClick('/library')} className='NavBarNewHamburger-selection-menu-repeater-item'>Databases</div>

                    {/* /pricing */}
                    <div onClick={() => handlePageButtonClick('/pricing')} className='NavBarNewHamburger-selection-menu-repeater-item'>Pricing</div>

                    {/* /contact */}
                    <div onClick={() => handlePageButtonClick('/contact')} className='NavBarNewHamburger-selection-menu-repeater-item'>Contact</div>

                </div>
            </div>
        </>
    )
};



// Export statement
export default NavBarNew;